(() => {
  if (window.__reOptInInit) return;
  window.__reOptInInit = true;

  function updateStickyPad() {
    let pad = 0;
    document.querySelectorAll('[data-re-opt-in-form][data-sticky="true"]').forEach((form) => {
      const panel = form.querySelector('.re-opt-in-form__panel');
      if (!panel) return;
      pad = Math.max(pad, panel.offsetHeight);
    });
    document.documentElement.style.setProperty('--re-opt-in-sticky-pad', pad + 'px');
  }

  updateStickyPad();

  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(updateStickyPad);
    document.querySelectorAll('[data-re-opt-in-form][data-sticky="true"] .re-opt-in-form__panel').forEach((panel) => {
      ro.observe(panel);
    });
  }

  window.addEventListener('resize', updateStickyPad);
})();
